<template>
  <div class="detail-pc" :style="`background:${bgcolor}`">
    <div class="user-info">
      <div class="name">{{current.name}}</div>
      <div v-if="current.number!='ACE0000'" class="num">{{current.number}}</div>
    </div>
    <div class="score">{{current.score||'--:--:--'}}</div>
    <div class="button-area">
      <van-button size="mini" icon="wap-home" :to="{name: 'checkinpc', query: $route.query}" />
    </div>
  </div>
</template>

<script>
import { getCheckinInfo, getCheckinConfig, cerateCert } from "../../libs/api";

export default {
  data() {
    return {
      clear: true,
      bgcolor: "#f4f4f4",
      current: {}
    };
  },
  mounted() {
    this.get_checkin_info();
  },
  methods: {
    get_checkin_config() {
      getCheckinConfig({ checkinid: this.$route.query.checkinid }).then(r => {
        if (r.data.backgroundimage) {
          this.bgcolor = `url(${r.data.backgroundimage}) no-repeat center center/100% 100%`;
        } else {
          if (r.data.backgroundcolor) {
            this.bgcolor = `#${r.data.backgroundcolor}`;
          } else {
            this.bgcolor = "#f4f4f4";
          }
        }
      });
    },
    format(num, size) {
      if (size == 2) {
        if (num <= 9) {
          return "0" + num;
        } else {
          return num;
        }
      } else if (size == 3) {
        if (num <= 9) {
          return "00" + num;
        } else if (num <= 99) {
          return "0" + num;
        } else {
          return num;
        }
      }
    },
    get_checkin_info() {
      getCheckinInfo({
        enrollid: this.$route.params.id,
        checkinid: this.$route.query.checkinid
      })
        .then(r => {
          this.get_checkin_config();

          if (r.data.score) {
            var d = this.$moment.duration(r.data.score * 1);
            var hours = this.format(d.hours(), 2);
            var minutes = this.format(d.minutes(), 2);
            var seconds = this.format(d.seconds(), 2);
            // var milliseconds = this.format(d.milliseconds(), 3);
            r.data.score = hours + ":" + minutes + ":" + seconds;
          }

          this.current = r.data;

          // if (!r.data.cert) {
          //   cerateCert({
          //     enrollid: r.data.id
          //   }).then(re => {
          //     this.current = re.data;
          //   });
          // } else {
          //   this.current = r.data;
          // }
        })
        .catch(r => {
          // ...
        });
    }
  }
};
</script>

<style scoped>
.detail-pc >>> .van-button--default {
  border-width: 0.01rem;
}
.detail-pc >>> .van-button--mini {
  min-width: 1.1rem;
}
</style>

<style lang="less" scoped>
.detail-pc {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .user-info {
    display: flex;
    align-items: center;
    font-size: 2.4rem;
    color: #393940;
    .num {
      margin-left: 2rem;
    }
  }
  .score {
    color: rgb(209, 0, 0);
    font-size: 2.6rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }
  .button-area {
    position: fixed;
    top: 0px;
    right: 0px;
    padding: 12px;
    font-size: 0;
  }
}
</style>